import { Decimal } from 'decimal.js';

// Standard Luxembourg VAT rate, used as the default for new invoice/credit/
// billing-period lines.
export const VAT_RATE = 0.17;

// Luxembourg VAT rates an operator can apply to a line: standard 17%,
// intermediate 14%, reduced 8%, super-reduced 3%, and 0% (exempt/zero-rated).
// The backend accepts any rate in [0, 1]; these are the ones the UI offers.
export const VAT_RATE_OPTIONS = [0.17, 0.14, 0.08, 0.03, 0] as const;

/** `Radio.Group` options for the VAT rate of a single line. */
export const VAT_RATE_CHOICES = VAT_RATE_OPTIONS.map((rate) => ({
  value: rate,
  label: `${new Decimal(rate).times(100).toNumber()}%`,
}));

/**
 * Snap a monetary amount to whole cents. Lines persisted before the gross total
 * was rounded carry sub-cent amounts (a 94.05 line at 17% VAT was stored as
 * 110.0385), so anything we show or re-submit has to be normalised on the way in
 * as well as on the way out.
 */
export const roundMoney = (amount: Decimal.Value) =>
  new Decimal(amount).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();

/** VAT-inclusive total from a pre-VAT unit price and the applicable rate. */
export const grossPrice = (unitPrice: number, taxRate: number) =>
  roundMoney(new Decimal(unitPrice).times(new Decimal(1).plus(taxRate)));
